import { render, staticRenderFns } from "./TabActivityPackage.vue?vue&type=template&id=557ce8a3"
import script from "./TabActivityPackage.vue?vue&type=script&lang=ts"
export * from "./TabActivityPackage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports